import CSVPreviewSection from './CSVPreviewSection'

export default function CSVParametersSection() {}

CSVParametersSection.prototype = new CSVPreviewSection()

CSVParametersSection.prototype.init = function ( parametersBuilder, totalNumOfColumns )
{
    CSVPreviewSection.prototype.init.call( this );
    this.parametersBuilder = parametersBuilder;
    this.totalNumOfColumns = totalNumOfColumns;
    return this;
};

CSVParametersSection.prototype.addRows = function ( tBody )
{
    const params = this.parametersBuilder.getParameters()
    for( let i = 0; i < params.length; i++ )
    {
        const row = this.createRow()
        row.className = "parametersRow" + i;
        ReportPreviewUtils.addCell( row, params[i][0], "paramNameCell" );
        ReportPreviewUtils.addCellWithFloatingContent( row, params[i][1] );
        ReportPreviewUtils.addEmptyCells( row, this.totalNumOfColumns - 2 );
        this.addRow( tBody, row );
    }

    const emptyRow = this.createRow()
    ReportPreviewUtils.addEmptyCells( emptyRow, this.totalNumOfColumns );
    this.addRow( tBody, emptyRow );
};



// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/CSVParametersSection.js